import { render } from "./DeviceSoftwareEditComponent.vue?vue&type=template&id=6562d04d"
import script from "./DeviceSoftwareEditComponent.vue?vue&type=script&lang=js"
export * from "./DeviceSoftwareEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__